// extracted by mini-css-extract-plugin
export default {"cls1":"AccountMenu-cls1_NXC","cls2":"AccountMenu-cls2_AV1 AccountMenu-cls1_NXC"};